import React, { useState, useEffect  } from 'react';
// import { useHistory } from "react-router-dom"

import { revenuecostService } from '../../Services/revenuecostService'

function Callback() {
    
    const [res, setRes] = useState('');
    // const history = useHistory()

    useEffect(() => {
        
        const url = window.location.href
        
        // if (window.opener) {
		// 	window.opener.location.href = url
		// 	window.close()
		// }
    //    console.log('history------------',history.go(-4))
        revenuecostService.createToken({url}).then(result => {

            if(result.status === true){
                setRes(JSON.stringify(result.message, null, 2))
                // history.go(-4)
                let redirectUri = localStorage.getItem('redirectUri')
                if(redirectUri !== '') window.location.href = redirectUri;
                else
                window.location.href = window.location.origin+'/admin';
            } else {
                setRes(JSON.stringify(result.message, null, 2))
            }
        
            /* revenuecostService.getCompanyInfo({companyID:realmId}).then(comRes => {
            }) */
        })
    },[]);

    return (
        <div>
            <p>{res}</p>
        </div>
    )
}

export { Callback };
